<script setup>
// Hic kanal bagli degilken gelen kutusu gorunumunde cikan bos ekran.
// Calls sayfasindaki CallsEmptyState ile ayni duzen.
//
// Metin role gore degisir: kanal baglamak yonetici isi. Temsilciye "bir kanal
// baglayin" demek anlamsizdi - dugmeyi zaten goremiyor, yapabilecegi bir sey
// yok. Ona durumu ve kime soylemesi gerektigini anlatiyoruz.
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAdmin } from 'dashboard/composables/useAdmin';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const { isAdmin } = useAdmin();

const altBaslik = computed(() =>
  isAdmin.value ? t('INBOX.SETUP.SUBTITLE') : t('INBOX.SETUP.SUBTITLE_AGENT')
);

const kanalKur = () => {
  router.push({
    name: 'settings_inbox_new',
    params: { accountId: route.params.accountId },
  });
};
</script>

<template>
  <EmptyStateLayout
    :title="t('INBOX.SETUP.TITLE')"
    :subtitle="altBaslik"
    :show-backdrop="false"
    :action-perms="['administrator']"
  >
    <template #actions>
      <Button
        :label="t('INBOX.SETUP.ACTION')"
        icon="i-lucide-plus"
        @click="kanalKur"
      />
    </template>
  </EmptyStateLayout>
</template>
